import Logger from "../../common/util/Logger";

const logger = new Logger("apiTools");

export const standardApiHandler = <Req, Resp>(api: (req: Req) => Promise<Resp>) => {
    return async (req: Req) => {
        try {
            return await api(req);
        } catch (error) {
            logger.error(`standardApiHandler ${JSON.stringify(error)}`, error as Error);
            throw error;
        }
    };
};
